import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Código Interno"
}, "Código Interno", -1)
const _hoisted_4 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_14 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Fechar", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "ant-row ss-grade-personalizada-titulo" }
const _hoisted_27 = { class: "ant-col ant-col-xs-18 ant-col-xl-19" }
const _hoisted_28 = { class: "ss-titulo-campo" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-6 ant-col-xl-5" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Principal")
], -1)
const _hoisted_30 = { class: "ant-col ant-col-xs-17 ant-col-xl-19" }
const _hoisted_31 = { class: "ss-margin-campos" }
const _hoisted_32 = { class: "ant-col ant-col-xs-5 ant-col-xl-3 ss-alinhar-centro" }
const _hoisted_33 = { class: "ant-col ant-col-xs-1 ant-col-xl-1 ss-alinhar-centro ss-margin-campos" }
const _hoisted_34 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_card, { titulo: "CÓDIGOS" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
              label: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_a_tooltip, {
                  placement: "top",
                  title: "Código único para identificação no ERP, deixe em branco para gerar automaticamente ou digite o código desejado."
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icone, {
                      class: "ss-icone-informacao-campo",
                      nome: "informacao-campo"
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    maxlength: "120",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigoInterno) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.computedCodigoInterno]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, {
              label: "Código de barras",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("input", {
                    type: "text",
                    maxlength: "50",
                    class: "ant-input",
                    value: _ctx.obterCodigoPrincipal(_ctx.ETipoCodigo.CodigoBarras),
                    disabled: ""
                  }, null, 8, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Gerenciar Códigos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gerenciarCodigos(_ctx.ETipoCodigo.CodigoBarras)))
                        }, [
                          _createVNode(_component_icone, { nome: "ordenar-lista" })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_form_item, {
              label: "Código Personalizado",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("input", {
                    type: "text",
                    maxlength: "50",
                    class: "ant-input",
                    value: _ctx.obterCodigoPrincipal(_ctx.ETipoCodigo.Personalizado),
                    disabled: ""
                  }, null, 8, _hoisted_11),
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Gerenciar Códigos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gerenciarCodigos(_ctx.ETipoCodigo.Personalizado)))
                        }, [
                          _createVNode(_component_icone, { nome: "ordenar-lista" })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_form_item, {
              label: "Código Balança",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, [
                  _createElementVNode("input", {
                    type: "text",
                    maxlength: "50",
                    class: "ant-input",
                    value: _ctx.obterCodigoPrincipal(_ctx.ETipoCodigo.CodigoBalanca),
                    disabled: ""
                  }, null, 8, _hoisted_15),
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_a_tooltip, {
                      placement: "top",
                      title: "Gerenciar Códigos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gerenciarCodigos(_ctx.ETipoCodigo.CodigoBalanca)))
                        }, [
                          _createVNode(_component_icone, { nome: "ordenar-lista" })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 500,
      visible: _ctx.state.apresentarCodigosModal,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.apresentarCodigosModal) = $event)),
      title: _ctx.obterDescricaoTipoCodigo(_ctx.state.tipoSelecionado),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-secondary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ocultarGerenciadorCodigos()))
          }, _hoisted_18),
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmarCodigos(_ctx.state.tipoSelecionado)))
          }, _hoisted_20)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_a_form_item, {
                  label: "Código",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      ref: "campoNovoCodigo",
                      type: "text",
                      maxlength: "50",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.novoCodigo) = $event)),
                      onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.adicionarCodigo()), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.state.novoCodigo]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-secondary ant-btn-block",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.adicionarCodigo()))
                    }, _hoisted_25)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.obterDescricaoTipoCodigo(_ctx.state.tipoSelecionado)), 1)
          ]),
          _hoisted_29
        ]),
        (_ctx.state.codigosModal.length <= 0)
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: 'Adicione os seus ' + _ctx.obterDescricaoTipoCodigo(_ctx.state.tipoSelecionado) + '.',
              adicionarDado: _ctx.state.apresentarCodigosModal
            }, null, 8, ["mensagem", "adicionarDado"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form, {
          name: "ss-form-produto-codigos",
          class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal",
          model: _ctx.state.codigosModal
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.codigosModal, (produtoCodigo, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ant-row ss-grade-personalizada-linha",
                key: index
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_input, {
                      class: "ant-input",
                      value: produtoCodigo.codigoProduto,
                      "onUpdate:value": ($event: any) => ((produtoCodigo.codigoProduto) = $event)
                    }, null, 8, ["value", "onUpdate:value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_a_checkbox, {
                    checked: produtoCodigo.principal,
                    "onUpdate:checked": ($event: any) => ((produtoCodigo.principal) = $event),
                    onChange: ($event: any) => (_ctx.defineApenasUmPrincipal(index,$event.target.checked)),
                    class: "ss-checkbox-grande"
                  }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-secondary",
                    title: "Remover",
                    onClick: ($event: any) => (_ctx.removerCodigo(index))
                  }, [
                    _createVNode(_component_icone, { nome: "excluir" })
                  ], 8, _hoisted_34)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}